import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
const WorkshopsPage = () => {
  return <div className="min-h-screen bg-white text-[#333333] font-serif" data-id="element-561">
      <Header data-id="element-562" />
      <main className="flex min-h-screen pt-24 px-6 pb-16" data-id="element-563">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-564">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-565">
            <Navigation data-id="element-566" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8" data-id="element-567">
            <div className="max-w-2xl" data-id="element-568">
              <div className="mb-8" data-id="element-569">Workshops for 2026</div>
              <div className="mb-8" data-id="element-570">
                <div className="mb-1" data-id="element-571">
                  The Winter Practice Workshop (Online)
                </div>
                <div className="mb-1" data-id="element-572">Saturdays 9am - 12pm EST</div>
                <div className="mb-1" data-id="element-573">January 24th - February 21st, 2026</div>
                <Link to="/winter-practice-workshop" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-574">
                  Register here
                </Link>
              </div>
              <div className="mb-8" data-id="element-575">
                <div className="mb-1" data-id="element-576">
                  Try Something New: 100 Images in Three Days
                </div>
                <div className="mb-1" data-id="element-577">
                  In-Person @{' '}
                  <a href="https://www.penumbrafoundation.org/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-578">
                    Penumbra Foundation
                  </a>
                </div>
                <div className="mb-1" data-id="element-579">April 22nd - April 24th, 2026</div>
                <div data-id="element-580">Details Coming Soon</div>
              </div>
              <div className="mb-8" data-id="element-581">
                <div className="mb-1" data-id="element-582">
                  The Sum of the Parts: A Writing and Photography Workshop
                </div>
                <div className="mb-1" data-id="element-583">
                  Co-led by{' '}
                  <a href="https://www.vivianewing.com/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-584">
                    Vivian Ewing
                  </a>
                </div>
                <div className="mb-1" data-id="element-585">
                  In-Person @{' '}
                  <a href="https://www.mainemedia.edu/workshops/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-586">
                    Maine Media Workshops
                  </a>
                </div>
                <div className="mb-1" data-id="element-587">August 24th - August 28th, 2026</div>
                <div data-id="element-588">Details Coming Soon</div>
              </div>
              <div className="mb-8" data-id="element-589">
                <div className="mb-1" data-id="element-590">
                  Photography & Storytelling: Thinking About the Photo Book
                </div>
                <div className="mb-1" data-id="element-591">
                  In-Person @{' '}
                  <a href="https://www.mainemedia.edu/workshops/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-592">
                    Maine Media Workshops
                  </a>
                </div>
                <div className="mb-1" data-id="element-593">
                  September 21st - September 25th, 2026
                </div>
                <div data-id="element-594">Details Coming Soon</div>
              </div>
              <div className="mb-12" data-id="element-595">
                <div data-id="element-596">
                  One-on-one mentorship follows the{' '}
                  <a href="https://santafeworkshops.com/sfw-online/mentorships/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-597">
                    Santa Fe Mentorship Level 1
                  </a>{' '}
                  model. Email me directly to enquire.
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default WorkshopsPage;